import ButtonToggle from '@redbubble/design-system/src/ButtonToggle';
import * as constants from '@redbubble/design-system/src/constants';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import React from 'react';

export const messages = defineMessages({
  followed: {
    defaultMessage: 'Follow',
  },
  following: {
    defaultMessage: 'Following',
  },
  followedOnRedbubble: {
    defaultMessage: 'Follow on Redbubble',
  },
  followingOnRedbubble: {
    defaultMessage: 'Following on Redbubble',
  },
});

export interface FollowArtistButtonProps {
  followingArtist?: boolean;
  handleOnToggleFollowArtist: (following: boolean) => void;
  longLabel?: boolean;
}

export const FollowArtistButton: React.FC<FollowArtistButtonProps> = ({
  handleOnToggleFollowArtist,
  followingArtist,
  longLabel = false,
}) => {
  const intl = useIntl();
  const handleOnClick = () => {
    handleOnToggleFollowArtist(!followingArtist);
  };

  const label = followingArtist
    ? intl.formatMessage(
        longLabel ? messages.followingOnRedbubble : messages.following
      )
    : intl.formatMessage(
        longLabel ? messages.followedOnRedbubble : messages.followed
      );

  return (
    <ButtonToggle
      data-testid="follow-artist-button"
      active={followingArtist}
      onClick={handleOnClick}
      size={constants.SMALL}
      aria-label={label}
    >
      {label}
    </ButtonToggle>
  );
};
